import React, { useState, useEffect } from 'react';
import { getUserDetails, } from '../../services/User_service';
import { getAllLogosByUser } from '../../services/Logo_service';
import CreationEURL from './AnnonceAssiste/signle-owner-limited-liability-company-creation/CreationEURL';
import CreationSARL from './AnnonceAssiste/creationSARL/CreationSARL';
import CreationSAS from './AnnonceAssiste/creationSAS/CreationSAS';
import CreationSocieteCivil from './AnnonceAssiste/civil-society-creation/CivilSocietyCreation';
import CreationAutreHorsForfait from './AnnonceAssiste/CreationAutreHorsForfait';
import CreationSCI from './AnnonceAssiste/creationSCI-SCCV/CreationSCI';
import CessionDroitBail from './AnnonceAssiste/cessionDroitDeBail/CessionDroitBail';
import CessionFondCommerce from './AnnonceAssiste/cessionFondCommerce/CessionFondCommerce';
import ChangementNomPatronique from './AnnonceAssiste/changeOfName/ChangementNomPatronique';
import ChangementRegimeMatrimonial from './AnnonceAssiste/ChangementRegimeMatrimonial';
import ModificationObjetSocial from './AnnonceAssiste/ModificationObjetSocial';
import ChangementAdministration from './AnnonceAssiste/ChangementAdministrateur';
import ChangementDureeSocial from './AnnonceAssiste/changementDureeSociete';
import ChangementDenomination from './AnnonceAssiste/ChangementDenomination';
import ModificationCapital from './AnnonceAssiste/ModificationDuCapital';
import RemplacementCAC from './AnnonceAssiste/RemplacementCAC';
import ModificationDirigeant from './AnnonceAssiste/ChangementDirigeant';
import ChangementAssocie from './AnnonceAssiste/ChangementAssocie';
import TransfertSiegeDepartement from './AnnonceAssiste/TransfertSiegeDepartement';
import TransfertHorsDepartement from './AnnonceAssiste/TransfertHorsDepartement';
import TransformationSARLenSAS from './AnnonceAssiste/TransformationSARLenSAS';
import TransformationSARLenSCI from './AnnonceAssiste/TransformationSARLenSCI';
import TransformationSASenSARL from './AnnonceAssiste/TransformationSASenSARL';
import TransformationAutre from './AnnonceAssiste/TransformationAutre';
import OuvertureDissolutionAnticipe from './AnnonceAssiste/OuvertureDissolutionAnticipe';
import ClotureDeLiquidation from './AnnonceAssiste/cloture-de-liquidation/ClotureDeLiquidation';
import DissolutionSansLiquidation from './AnnonceAssiste/DissolutionSansLiquidation';
import ContinuationActiviteMalgresPerte from './AnnonceAssiste/ContinuationActiviteMalgrePerte';
import AnnonceAdditive from './AnnonceAssiste/AnnonceAdditive';
import AnnonceRectificative from './AnnonceAssiste/AnnonceRectificative';
import AutreRedactionLibre from './AnnonceAssiste/AutreRedactionLibre';
import LocationGerance from './AnnonceAssiste/LocationGerance';
import FinDeLocationGerance from './AnnonceAssiste/FinDeLocationGerance';
import AcceptationDeLaSuccession from './AnnonceAssiste/AcceptationDeLaSuccession';
import EnvoyePossesion from './AnnonceAssiste/possession-sending/PossessionSending';
import DeclarationInsaisissabilite from './AnnonceAssiste/DeclarationInsaisissabilite';
import CreationSASU from './AnnonceAssiste/crearionSASU/CreationSASU';
import GeneralPartnershipCreation from './AnnonceAssiste/general-partnership-creation/GeneralPartnershipCreation';
import CreationGAEC from './AnnonceAssiste/common-agricultural-operating-group-creation/CreationGAEC';
import LimitedCompanyCreation from './AnnonceAssiste/limited-company-creation/LimitedCompanyCreation';
import ModificationsMultiples from './AnnonceAssiste/multiple-modifications/ModificationsMultiples';
import { Link } from 'react-router-dom';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaInfoCircle } from 'react-icons/fa';
import CreationScopSA from './AnnonceAssiste/creation-scop/CreationScopSA';
import CreationScopSARL from './AnnonceAssiste/creation-scop/CreationScopSARL';
import CreationScopSAS from './AnnonceAssiste/creation-scop/CreationScopSAS';
import TransferOutsideDepartmentArrival from './AnnonceAssiste/transfer-outside-department/TransferOutsideDepartmentArrival';
import useAppContext from '../../hooks/useAppContext';
import { AppContextType } from '../../context/AppContext';
import { useDraftManager } from '../../hooks/useDraftManager';


interface AnnonceProps {
  onValidate: (isValid: boolean) => void;
  // onSubmit: (texteAnnonce: string) => void;
  txtAnnonce: string;
  selectedType: string | undefined;  // Le type sélectionné
  activeIndex: number;
  updateActiveIndex: (index: number) => void;
  denomination: string;
  updateTxtAnnonce: (newTxt: string) => void;
  updateDenomination: (newTxt: string) => void;
  societyType: string | string[];
  updatesocieteSelected: (newTxt: string) => void;
  updateFloid: (newTxt: string) => void;
  updateEntete: (newTxt: string) => void;
  floid: string;
  entete: string;
}
interface Logo {
  id: number;
  libelle: string;
  user_id?: number;
  floId?: string;
  logo_status: string;
}

const AnnonceAssiste: React.FC<AnnonceProps> = ({
  onValidate,
  // onSubmit,
  txtAnnonce,
  activeIndex,
  updateActiveIndex,
  selectedType,
  updateTxtAnnonce,
  denomination,
  updateDenomination,
  updatesocieteSelected,
  societyType,
  floid,
  updateFloid,
  entete,
  updateEntete,
}) => {

  const {
    choix, setChoix,
    draftFormData,
    setLogoLibelle,

  } = useAppContext() as AppContextType

  const { pushDraftContent } = useDraftManager()

  const [typeChoice, setTypeChoice] = useState('');
  const [errors, setErrors] = useState<{ denomination?: string; texteAnnonce?: string }>({});
  const [date, setDate] = useState<string>('');
  const options = Array.isArray(societyType) ? societyType : [societyType];
  const [selectedLogos, setSelectedLogos] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [fullscreenImage, setFullscreenImage] = useState<string | null>(null);

  const handleCheckboxChange = (logoId: number) => {
    setSelectedLogos((prevSelected) => {
      const isCurrentlySelected = prevSelected.includes(logoId);
      const newSelected = isCurrentlySelected
        ? prevSelected.filter(id => id !== logoId)
        : [logoId];

      pushDraftContent({ selectedLogos: newSelected });

      const selectedLogo = logos.find(logo => logo.id === logoId);
      if (selectedLogo) {
        if (!isCurrentlySelected && selectedLogo.floId) {
          // Logo sélectionné
          updateFloid(selectedLogo.floId);
          setLogoLibelle(selectedLogo.libelle);
          console.log("✅ Logo sélectionné:", {
            id: logoId,
            floId: selectedLogo.floId,
            libelle: selectedLogo.libelle
          });
        }
        else if (isCurrentlySelected) {
          // Logo désélectionné
          updateFloid("");
          setLogoLibelle("");
          console.log("❌ Logo désélectionné");
        }
      }
      return newSelected;
    });
  };


  useEffect(() => {
    if (floid) updateFloid(floid)
  }, [])
  // Charger selectedLogos depuis draftFormData
  useEffect(() => {
    if (draftFormData) {
      try {
        const parsedData = typeof draftFormData === 'string' ? JSON.parse(draftFormData) : draftFormData;
        if (parsedData.selectedLogos && Array.isArray(parsedData.selectedLogos)) {
          setSelectedLogos(parsedData.selectedLogos);
        }
      } catch (error) {
        console.error('Erreur lors du chargement de selectedLogos depuis draftFormData:', error);
      }
    }
  }, [draftFormData]);
  useEffect(() => {
    onValidate(validate());
  }, [denomination, txtAnnonce, onValidate]);


  const API_URL = process.env.REACT_APP_API_BASE;
  const [logos, setLogos] = useState<Logo[]>([]);

  // Options pour l'en-tête
  const choixOptions = [
    { value: 'option1', label: 'Pas en-tête' },
    { value: 'option2', label: 'En-tête sans logo' },
    { value: 'option3', label: 'En-tête avec logo' },
    { value: 'option4', label: 'Logo uniquement' },
  ];

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        localStorage.removeItem('logos');
        const fetchedLogos = await getAllLogosByUser();

        // Ajouter le typage explicite ici
        const acceptedLogos = fetchedLogos.filter((logo: Logo) =>
          logo.logo_status === 'accepted'
        );

        setLogos(acceptedLogos);
        localStorage.setItem('logos', JSON.stringify(acceptedLogos));
      } catch (error) {
        console.error('Erreur lors de la récupération des logos:', error);
      }
    };

    fetchLogos();
  }, []);

  const [user, setUser] = useState({
    name: '',
    firstname: '',
    email: '',
    reference: '',
    civility: '',
    code_parrainage: '',
    adresse: '',
    number: '',
    country: '',
    postal_code: '',
    dateCreation: '',
    raison_social: '',
    code_SIREN: '',
    code_NAF: '',
    tv_intra: '',
    status: '',
    is_validated: false,
  });

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const userData = await getUserDetails();
      if (userData) {
        setUser({
          name: userData.name || '',
          firstname: userData.firstname || '',
          email: userData.email || '',
          reference: userData.reference || '',
          civility: userData.civility || '',
          code_parrainage: userData.code_parrainage || '',
          adresse: userData.adresse || '',
          number: userData.number || '',
          country: userData.country || '',
          postal_code: userData.postal_code || '',
          dateCreation: userData.createdAt ? new Date(userData.createdAt).toLocaleDateString() : '',
          raison_social: userData.raison_social || '',
          code_SIREN: userData.code_SIREN || '',
          code_NAF: userData.code_NAF || '',
          tv_intra: userData.tv_intra || '',
          status: userData.status || '',
          is_validated: userData.is_validated || false,
        });
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  // Validation des champs
  const validate = () => {
    const newErrors: { denomination?: string; texteAnnonce?: string } = {};
    if (!denomination) newErrors.denomination = "Le champ 'Dénomination' est obligatoire.";
    if (!txtAnnonce) newErrors.texteAnnonce = "Le champ 'Texte d'annonce' est obligatoire.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openFullscreen = (image: string) => {
    setFullscreenImage(image);
  };

  // Effet pour vérifier la validation à chaque changement de dénomination ou d'annonce
  useEffect(() => {
    const isValid = validate();
    onValidate(isValid);
  }, [denomination, txtAnnonce, onValidate]);

  // Affichage conditionnel selon selectedType
  const renderContentBySelectedType = () => {
    switch (selectedType) {


      case 'Création EURL':
        return <CreationEURL
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />

      case 'Création GAEC':
        return <CreationGAEC
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;


      case 'Création SA':
        return <LimitedCompanyCreation
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Création SARL - SELARL':
        return <CreationSARL
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Création SAS':
        return <CreationSAS
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Création SASU':
        return <CreationSASU
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Création SCI - SCCV':
        return <CreationSCI
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Création SNC':
        return <GeneralPartnershipCreation
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles 
        />;

      case 'Création Société Civile':
        return <CreationSocieteCivil
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles 
        />;

      case 'Création autre hors forfait':
        return <CreationAutreHorsForfait
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles 
        />;



      case 'Cession de droit au bail':
        return <CessionDroitBail
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles 
        />;

      case 'Cession de fonds de commerce':
        return <CessionFondCommerce
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Changement de nom patronymique':
        return <ChangementNomPatronique
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;

      case 'Changement de régime matrimonial':
        return <ChangementRegimeMatrimonial
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} // Passe les options disponibles
        />;
      case 'Modification d\'objet social':
        return <ModificationObjetSocial
          txtAnnonce={txtAnnonce}
          updateTxtAnnonce={updateTxtAnnonce}
          updateDenomination={updateDenomination}
          activeIndex={activeIndex}
          updateActiveIndex={updateActiveIndex}
          societeSelected={typeChoice} // Passe la valeur sélectionnée
          updatesocieteSelected={updatesocieteSelected}
          societyType={options} />;

      case 'Nomination / Départ / Remplacement d\'administrateur':
        return (
          <ChangementAdministration
            txtAnnonce={txtAnnonce}
            updateTxtAnnonce={updateTxtAnnonce}
            updateDenomination={updateDenomination}
            updateActiveIndex={updateActiveIndex}
            societeSelected={typeChoice}         // Passe la valeur sélectionnée
            updatesocieteSelected={updatesocieteSelected}
            societyType={options}
            denomination={''}
            activeIndex={activeIndex}
          />
        );

      case 'Changement de durée': return <ChangementDureeSocial
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        denomination={''}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} //
      />

      case 'Changement de dénomination': return <ChangementDenomination
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Modification du capital': return <ModificationCapital
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options}
      />

      case 'Nomination / Départ / Remplacement de CAC': return <RemplacementCAC
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        activeIndex={activeIndex} updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options}
      />



      // RANDRIANASOAVINA FANILONIAINA
      case "Continuation d'activité malgré pertes": return <ContinuationActiviteMalgresPerte
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />
      case "Déclaration d'insaisissabilité": return <DeclarationInsaisissabilite
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Envoi en possession": return <EnvoyePossesion
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Acceptation de la succession à concurrence de l'actif net": return <AcceptationDeLaSuccession
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Fin de location gérance": return <FinDeLocationGerance
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Location gérance": return <LocationGerance
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Autre (rédaction libre)": return <AutreRedactionLibre
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Annonce rectificative": return <AnnonceRectificative
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      case "Annonce additive": return <AnnonceAdditive
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice} // Passe la valeur sélectionnée
        updatesocieteSelected={updatesocieteSelected}
        societyType={options} // Passe les options disponibles
      />
      // RANDRIANASOAVINA FANILONIAINA


      // Manambina

      case 'Changement de dirigeant': return <ModificationDirigeant
        onValidate={onValidate}
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex} updateActiveIndex={updateActiveIndex}
        denomination={''}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />
      case 'Changement d\'associé': return <ChangementAssocie
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Transfert de siège dans le département': return <TransfertSiegeDepartement
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        activeIndex={activeIndex} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Transfert siège hors département (Annonce de départ)': return <TransfertHorsDepartement
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Transfert siège hors département (Annonce d\'arrivée)': return <TransferOutsideDepartmentArrival
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Transformation SARL en SAS': return <TransformationSARLenSAS
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Transformation SARL en SCI': return <TransformationSARLenSCI
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />
      case 'Transformation SAS en SARL': return <TransformationSASenSARL
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} activeIndex={activeIndex}
        updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />
      case 'Transformation Autre': return <TransformationAutre
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
      />

      case 'Modifications multiples': return <ModificationsMultiples
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Ouverture Dissolution Anticipée': return <OuvertureDissolutionAnticipe
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Clôture de liquidation': return <ClotureDeLiquidation
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'TUP - Dissolution sans liquidation': return <DissolutionSansLiquidation
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Création SCIC - SCOP SA': return <CreationScopSA
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination} updateActiveIndex={updateActiveIndex}
        societyType={options}
        societeSelected={'typeChoice'}
        updatesocieteSelected={updatesocieteSelected}
      />

      case 'Création SCIC - SCOP SARL': return <CreationScopSARL
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice}
        updatesocieteSelected={updatesocieteSelected}
        societyType={options}
      />

      case 'Création SCIC - SCOP SAS': return <CreationScopSAS
        txtAnnonce={txtAnnonce}
        updateTxtAnnonce={updateTxtAnnonce}
        updateDenomination={updateDenomination}
        updateActiveIndex={updateActiveIndex}
        societeSelected={typeChoice}
        updatesocieteSelected={updatesocieteSelected}
        societyType={options}
      />
    }
  };

  // Gestion du changement de sélection pour l'en-tête
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setChoix(event.target.value);
    if (['option2', 'option3'].includes(event.target.value) && entete) {
      updateEntete(entete)
    }
    else if (['option2', 'option3'].includes(event.target.value)) {
      const enteteText = `${user.raison_social || ''} ${user.adresse || ''} ${user.postal_code || ''} ${user.country || ''}`
      updateEntete(enteteText)
    }
    else updateEntete('')

  };

  useEffect(() => {
    updateEntete('')
  }, [])

  return (
    <div className="container mt-2">
      <div className="container mt-2">
        <h6 className="mx-3 bg-col mt-2"></h6>
      </div>

      <h6 className="border-bottom pb-2 bg-orange">EN-TETE DU CABINET</h6>

      {user.status !== "anonymous" && user.is_validated === true ? (<div className="mb-3 row">
        <label htmlFor="choix" className="col-sm-3 col-form-label">
          Choisir
        </label>
        <div className="col-sm-9">
          <select
            className="form-select"
            id="choix"
            onChange={handleSelectChange}
            value={choix}
          >
            {choixOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      ) : (
        !user?.is_validated && user?.status !== "anonymous" && (
          <div
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: "#E6F7FA",
              borderRadius: "8px",
              textAlign: "center",
              border: "1px solid #4BB0C0",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                color: "#4BB0C0",
              }}
            >
              Votre compte est en cours de validation, vous pourrez choisir un en-tête et un logo une fois validé.
            </span>
          </div>
        )
      )
      }
      {/* Affichage conditionnel basé sur le choix sélectionné */}
      {choix === 'option2' && (
        <div className="mb-3 row">
          <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
          <div className="col-sm-9">
            <input
              className="form-control w-100 custom-textarea"
              id="entete"
              defaultValue={entete}
              readOnly
              style={{ color: 'black' }}
            />
          </div>
        </div>
      )}
      {choix === 'option3' && <div className="bg-light p-3 ">
        <div>
          <label htmlFor="choix" className="col-sm-3 col-form-label">En-tête du cabinet</label>
          <div className="col-sm-9">
            <input
              className="form-control w-100 custom-textarea"
              id="entete"
              defaultValue={entete}
              readOnly
              style={{ color: 'black' }}
            />
          </div>
        </div>
        <div className='ok mt-3 align-items-center'>
          {
            logos?.length ? logos.map((logo) => (
              <div key={logo.id} className="col-md-2 mx-2">
                <label>
                  <input
                    type="radio"
                    name='logoOption3Assiste'
                    value={floid}
                    checked={selectedLogos.includes(logo.id)}
                    onChange={() => handleCheckboxChange(logo.id)}
                  />
                  <div style={{ width: "125px", height: "125px" }}>
                    <img
                      src={`${API_URL}/${logo.libelle}`}
                      alt={`Logo ${logo.id}`}
                      id="card-img-top"
                      onClick={() => openFullscreen(logo.libelle)}
                      style={{ cursor: 'pointer', width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                </label>
              </div>
            ))
              :
              <p>
                <FaInfoCircle size={35} className="bg-col me-2" />
                Vous n'avez pas encore de logo, veuillez cliquer ici pour l'ajouter  <Link to="/home/gestion-logos" className=""><span className='bg-col' style={{ fontSize: '1.1em' }}>&laquo;
                  <FontAwesomeIcon icon={faImage} aria-hidden="true" className="ico mx-2" style={{ color: "#2A919D", marginBottom: '7px' }} />
                  Gestion des logos &raquo;</span> </Link>
              </p>
          }
        </div>
      </div>
      }
      {choix === 'option4' && <div className="bg-light p-3 ok">
        {logos?.length ? logos.map((logo) => (
          <div key={logo.id} className="col-md-2 mx-2">
            <label>
              <input
                type="radio"
                name="logoOption4Assiste"
                checked={selectedLogos.includes(logo.id)}
                onChange={() => handleCheckboxChange(logo.id)}
              />
              <div style={{ width: "125px", height: "125px", marginRight: "10px" }}>
                <img
                  src={`${API_URL}/${logo.libelle}`}
                  alt={`Logo ${logo.id}`}
                  id="card-img-top"
                  onClick={() => openFullscreen(logo.libelle)}
                  style={{ cursor: 'pointer', width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </label>
          </div>
        )) :
          <p>
            <FaInfoCircle size={35} className="bg-col me-2" />
            Vous n'avez pas encore de logo, veuillez cliquer ici pour l'ajouter  <Link to="/home/gestion-logos" className=""><span className='bg-col' style={{ fontSize: '1.1em' }}>&laquo;
              <FontAwesomeIcon icon={faImage} aria-hidden="true" className="ico mx-2" style={{ color: "#2A919D", marginBottom: '7px' }} />
              Gestion des logos &raquo;</span> </Link>
          </p>
        }
      </div>}
      <div className="mt-4">
        {renderContentBySelectedType()}
      </div>
    </div>
  );
};

export default AnnonceAssiste;